<template>
  <div style="height: calc(100vh - 48px); position:relative;">
    <mx-preloader :loader-status="preloader"/>
    <v-container fluid>
      <v-row class="mt-3">
        <v-col cols="12">
          <TableFullEmployeeCRM path="crm" @tableCreated="tableCreated" @getId="getId"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import TableFullEmployeeCRM from "@/components/Tables/TableFullEmployeeCRM";

export default {
  components: { TableFullEmployeeCRM },
  data() {
    return {
      preloader: true,
      search: {
        search: null,
        search_select: 'identification'
      },
      search_from: [
        {
          text: 'Identification',
          value: 'identification'
        },
        {
          text: 'First name',
          value: 'first_name'
        },
        {
          text: 'Last name',
          value: 'last_name'
        },
        {
          text: 'Birthday',
          value: 'birthday'
        }
      ],
      customers: [],
      meta: {},
      customer_id: null
    }
  },
  created () {
    setTimeout(this.mxPreloader, 700)
  },
  methods: {
    tableCreated(bool) {
      this.preloader = !bool
    },
    getId(id) {
      this.customer_id = id
    },
    mxPreloader() {
      this.preloader = false
    }
  }
}
</script>
